export default "__VITE_ASSET__BMK3CURR__"